var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card-subtitle',{staticClass:"pb-0 pt-0 mt-n2 px-4",class:[_vm.dense === true ? 'text-truncate' : null]},[(_vm.video.lang)?_c('span',[_vm._v(_vm._s(_vm.video.lang.subtitle))]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }